/*
* Particle manager singleton
*/

import DomParticles from 'dom-particles';

const Particles = new DomParticles({ container: document.querySelector('.wrapper') });

export default Particles;
